import {
  MatrizActivoComponent
} from '../../../componentes/01-presupuesto/matrices/matriz-activo/matriz-activo.component';
import {ClsUtil} from '../../../util/cls-util';
import {IgxGridComponent} from '@infragistics/igniteui-angular/grids/grid';
import {Transaction, TransactionType} from '@infragistics/igniteui-angular/core';
import {GenericoService} from '../../../core/services/generico.service';
import {AppPresupuestosService} from '../../../core/services/app-presupuestos.service';
import {AppInfoService} from '../../../core/services/app-info.service';
import {ClsConfig} from '../../../util/cls-config';
import {EnumMCExpInsumos, EnumMCGenerales, EnumMCMatriz} from '../../../core/models/enum/enum-menu-contextual';
import {INeodataMenu} from '../../../core/models/interfaces/generico-interface';
import {
  DmSecundarioComponent
} from '../../../componentes/00-contenedores/docker-manager/dmseundario/dm-secundario.component';
import {EnumMenuOpIDPpto, EnumMenuOpIDPrincipal} from '../../../core/models/enum/enum-menus-opciones';
import {
  ClsPeticionGuardarMatriz,
  ClsPeticionMatrices,
  ClsPeticionRegistraActualizaPendAnalisar,
  ClsRespuestaMatrices,
  ClsRespuestaTodasLasMatrices
} from '../../../core/models/peticiones/cls-pr-matriz';
import {ClsRespuestaGuardarConceptos} from '../../../core/models/peticiones/cls-pr-concepto';
import {ClsObjGenerico} from '../../util/cls-obj-generico';
import {ClsObjExplosionDeInsumos} from '../menu-presupuesto/cls-obj-explosion-de-insumos';
import {ClsPeticionConsultarGralsCatalogos} from '../../../core/models/peticiones/catalogos/cls-pr-catalogos';
import {IgcContentPane} from '@infragistics/igniteui-dockmanager';
import {ClsObjViewer} from '../../99-herramientas/reportes/cls-obj-viewer';
import {
  ClsDetalleMatrizInsumos,
  ClsGuardarMatriz,
  ClsGuardarMatrizDetalle,
  ClsMatriz
} from "../../../core/models/cls-matriz";
import {ClsConceptosPartida} from "../../../core/models/cls-partida";
import {ClsCatalogosExpIns, ClsCatalogosExpIns2} from "../../../core/models/cls-catalogo-general";
import {ClsCalculoMatriz} from "../../../core/models/cls-calculo";
import {ClsGuardarConceptosPartidaDetalle} from "../../../core/models/cls-concepto";
import {ClsImportePorTipo, ClsPartidasConceptosExpIns} from "../../../core/models/cls-presupuestos";
import {ClsErrores} from "../../../core/models/cls-errores";
import {inject} from "@angular/core";
import {EnumMasOpciones} from "../../../core/models/enum/enum-mas-opciones";
import {ClsVectorSearchRow} from "../../../core/models/cls-busqueda-ai";
import {IndexedDbService} from "../../../core/services/indexed-db-service.service";

export class ClsObjMatrices extends ClsConfig {
  public gridMatriz: IgxGridComponent;
  // arreglos para filtrado
  public gridDataCompleta: ClsDetalleMatrizInsumos[] = [];
  private gridDataFiltrada: ClsDetalleMatrizInsumos[] = [];
  // solo se manda desde conceptos o ppto completo
  public gridDesdeDondeSeBuscoLaMatriz: IgxGridComponent;
  public nombreColumna: string;
  public datosConceptosFiltradosPartida: ClsConceptosPartida[];
  public desdeConceptos: boolean;
  public insumos: ClsDetalleMatrizInsumos[] = [];
  public tipoMatrizDefault = 1;
  // traer por bonches
  private offset: number;
  public mLMatrices: ClsMatriz[] = [];
  // menu contextual
  private menus: INeodataMenu[] = [];

  private infPpto = inject(AppPresupuestosService);
  private servicioGen = inject(GenericoService);
  private infApp = inject(AppInfoService);
  private indexedDb = inject(IndexedDbService);

  constructor() {
    super();
  }

  public esRegistroMatrizValido(
    registro:
      | Pick<ClsCatalogosExpIns, 'Nivel' | 'EsCostoHorario' | 'EsPorcentaje'>
      | Pick<ClsDetalleMatrizInsumos, 'Nivel' | 'EsCostoHorario' | 'EsPorcentaje'>
      | undefined
  ) {
    if (!registro) {
      return false;
    }

    return (
      (registro.Nivel ?? 0) > 0 &&
      !Boolean(registro.EsCostoHorario) &&
      !Boolean(registro.EsPorcentaje)
    );
  }

  private esCatalogoMatriz(catalogo: ClsCatalogosExpIns | undefined) {
    return this.esRegistroMatrizValido(catalogo);
  }

  public inicializarComponenteComoMaestro(componente: MatrizActivoComponent, maestro: boolean) {
    if (maestro || !this.infApp.mostrarexpinsacoplado) {
      // componente.masOpcionesG.arrayDatosAVer = [0, 5];
      // componente.masOpcionesG.filtrarDatosAVer();
      componente.paneTopSize = '10%';
      componente.paneMiddleSize = '89%';
      componente.paneBottomSize = '0%';
    } else {
      // componente.masOpcionesG.arrayDatosAVer = [0, 1, 5];
      // componente.masOpcionesG.filtrarDatosAVer();
      componente.paneTopSize = '10%';
      componente.paneMiddleSize = '50%';
      componente.paneBottomSize = '39%';
    }
    componente.ExpInsumoAcoplado.inicialarComoMaestro(maestro);
  }

  public async verMatriz(idCatalogo: bigint, index: number) {
    try {
      const dmSecundario: DmSecundarioComponent = ClsUtil.getDMSecundarioActivoMaestro(this.infPpto);
      // validamos si tiene cambios por guardar, para no permitir abrir otra matriz
      if (dmSecundario.MActivo?.hasTransactions) {
        throw new Error('MENSAJES.ALERT.CAMBIOS_SIN_GUARDAR_MATRIZ');
      }
      // hacer focus en el tab Maestro o Ppto activo
      const panelesPrin: IgcContentPane[] = this.infPpto.dmPrincipal.getPaneles(this.infPpto.esPptoMaestro ? EnumMenuOpIDPrincipal.PptoMaestro : EnumMenuOpIDPrincipal.PptoActivo);
      this.infPpto.dmPrincipal.refrescarLayou(this.infPpto.dmPrincipal.rutaAux.indexOf(panelesPrin[0]));
      await dmSecundario.crearTabDockManager(ClsUtil.crearContentPane(EnumMenuOpIDPpto.MA, 'Matriz', true, 'Matriz'));
      dmSecundario.MActivo.inicializarComoMaestro(this.infPpto.esPptoMaestro);
      dmSecundario.MActivo.gridMatriz.rowEditable = false;
      dmSecundario.MActivo.indexMatrizSeleccionado = index;
      dmSecundario.MActivo.conceptosPartida = this.datosConceptosFiltradosPartida;
      dmSecundario.MActivo.gridDesdeDondeSeBuscoLaMatriz = this.gridDesdeDondeSeBuscoLaMatriz;
      dmSecundario.MActivo.nombreColumna = this.nombreColumna;
      await dmSecundario.MActivo.obtenerMatrizObjMemoria(idCatalogo, this.desdeConceptos);
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public crearMenuContextual(esMaestro: boolean, esCH: boolean) {
    let enEdicion: boolean;
    this.menus = [];
    const subLayout: INeodataMenu[] = [
      {
        id: EnumMasOpciones.Ajustar,
        descripcion: 'MENUCONTEXTUAL.ALTO_FILA',
        icono: 'wrap_text',
        disabled: false,
        divisor: true
      },
      {
        id: EnumMCGenerales.GuardarLayout,
        descripcion: 'MENUCONTEXTUAL.GUARDAR_LAYOUT',
        icono: 'save',
        disabled: false,
        divisor: false
      },
      {
        id: EnumMCGenerales.ReestablecerLayout,
        descripcion: 'MENUCONTEXTUAL.RESTABLECER_LAYOUT',
        icono: 'restore',
        disabled: false,
        divisor: false
      }
    ];
    if (esMaestro) {
      enEdicion = false;
    }
    if (!esMaestro) {
      enEdicion = this.infPpto.enEdicionMatriz;
      esMaestro = !enEdicion;
    }
    if (!enEdicion && !esCH) {
      this.menus.push({
        id: EnumMCGenerales.Matriz,
        descripcion: 'MENUCONTEXTUAL.VER_MATRIZ',
        icono: 'folder',
        disabled: false,
        divisor: false
      });
    }
    if (!enEdicion && esCH) {
      this.menus.push({
        id: EnumMCGenerales.CostoHorario,
        descripcion: 'MENUCONTEXTUAL.VER_COSTOHORARIO',
        icono: 'folder',
        disabled: false,
        divisor: false
      });
    }
    this.menus.push({
      id: EnumMCGenerales.AplicarExpresion,
      descripcion: 'MENUCONTEXTUAL.APLICAR_EXPRESION',
      icono: 'functions',
      disabled: esMaestro,
      divisor: false
    });
    this.menus.push({
      id: EnumMCExpInsumos.CambiarPropiedadesTipo,
      descripcion: 'MENUCONTEXTUAL.CAMBIAR_PROP',
      icono: '123',
      disabled: esMaestro,
      divisor: false
    });
    this.menus.push({
      id: EnumMCMatriz.AjustarPrecioUnitario,
      descripcion: 'MENUCONTEXTUAL.AJUSTAR_PRECIO',
      icono: 'price_change',
      disabled: esMaestro,
      divisor: true
    });
    // this.menus.push({ id: EnumMCMatriz.RecuperarMatrizOriginal, descripcion: 'Recuperar matriz original', icono: 'undo', disabled: esMaestro, divisor: false  });
    // this.menus.push({ id: EnumMCMatriz.Participa, descripcion: 'MENUCONTEXTUAL.PARTICIPA', icono: '', disabled: esMaestro, divisor: false  });
    this.menus.push({
      id: EnumMCMatriz.Participa,
      descripcion: 'MENUCONTEXTUAL.PARTICIPA',
      icono: 'dynamic_feed',
      disabled: false,
      divisor: true
    });
    this.menus.push({
      id: EnumMCGenerales.MarcarTodo,
      descripcion: 'MENUCONTEXTUAL.MARCAR_TODO',
      icono: 'check_box',
      disabled: false,
      divisor: false
    });
    this.menus.push({
      id: EnumMCGenerales.DesmarcarTodo,
      descripcion: 'MENUCONTEXTUAL.DESMARCAR_TODO',
      icono: 'remove_done',
      disabled: false,
      divisor: false
    });
    // this.menus.push({ id: EnumMCGenerales.SeleccionarTodo, descripcion: 'MENUCONTEXTUAL.SELECCIONAR_TODO', icono: 'check', disabled: esMaestro, divisor: false  });
    // this.menus.push({ id: EnumMCGenerales.DeseleccionarTodo, descripcion: 'MENUCONTEXTUAL.DESELECCIONAR_TODO', icono: 'close', disabled: esMaestro, divisor: false  });
    this.menus.push({
      id: EnumMCGenerales.Copiar,
      descripcion: 'MENUCONTEXTUAL.COPIAR',
      icono: 'content_copy',
      disabled: esMaestro,
      divisor: false
    });
    this.menus.push({
      id: EnumMCGenerales.Pegar,
      descripcion: 'MENUCONTEXTUAL.PEGAR',
      icono: 'content_paste',
      disabled: esMaestro,
      divisor: false
    });
    this.menus.push({
      id: '_layout',
      descripcion: 'MENUCONTEXTUAL.LAYOUT',
      icono: 'grid_on',
      disabled: false,
      divisor: true,
      subMenu: subLayout
    });
    return this.menus;
  }

  public crearMenuContextualBusqAI(esMatriz: boolean) {
    this.menus = [];
    if (esMatriz) {
      this.menus.push({ id: EnumMCGenerales.DetalleRegistro, descripcion: 'MENUCONTEXTUAL.DETALLE_MATRIZ', icono: 'folder', disabled: false, divisor: false });
    }
    return this.menus;
  }

  public crearMenuContextualBusqueda(puedeVerMatriz: boolean) {
    // let enEdicion: boolean;
    this.menus = [];
    if (!puedeVerMatriz) {
      // this.menus.push({ id: EnumMCGenerales.CostoHorario, descripcion: 'MENUCONTEXTUAL.VER_COSTOHORARIO', icono: 'folder', disabled: false, divisor: true  });
    } else {
      this.menus.push({
        id: EnumMCGenerales.Matriz,
        descripcion: 'MENUCONTEXTUAL.VER_MATRIZ',
        icono: 'folder',
        disabled: false,
        divisor: true
      });
    }
    // this.menus.push({ id: EnumMCGenerales.AplicarExpresion, descripcion: 'MENUCONTEXTUAL.APLICAR_EXPRESION', icono: 'functions', disabled: esMaestro, divisor: false  });
    // this.menus.push({ id: EnumMCExpInsumos.CambiarPropiedadesTipo, descripcion: 'MENUCONTEXTUAL.CAMBIAR_PROP', icono: '123', disabled: esMaestro, divisor: true });
    // this.menus.push({ id: EnumMCMatriz.RecuperarMatrizOriginal, descripcion: 'Recuperar matriz original', icono: 'undo', disabled: esMaestro, divisor: false  });
    // this.menus.push({ id: EnumMCMatriz.Participa, descripcion: 'MENUCONTEXTUAL.PARTICIPA', icono: '', disabled: esMaestro, divisor: false  });
    // this.menus.push({ id: EnumMCMatriz.Participa, descripcion: 'MENUCONTEXTUAL.PARTICIPA', icono: 'dynamic_feed', disabled: false, divisor: false  });
    // this.menus.push({ id: EnumMCGenerales.MarcarTodo, descripcion: 'MENUCONTEXTUAL.MARCAR_TODO', icono: 'check_box', disabled: false, divisor: false  });
    // this.menus.push({ id: EnumMCGenerales.DesmarcarTodo, descripcion: 'MENUCONTEXTUAL.DESMARCAR_TODO', icono: 'remove_done', disabled: false, divisor: false  });
    this.menus.push({
      id: EnumMCGenerales.SeleccionarTodo,
      descripcion: 'MENUCONTEXTUAL.SELECCIONAR_TODO',
      icono: 'check',
      disabled: false,
      divisor: false
    });
    this.menus.push({
      id: EnumMCGenerales.DeseleccionarTodo,
      descripcion: 'MENUCONTEXTUAL.DESELECCIONAR_TODO',
      icono: 'close',
      disabled: false,
      divisor: false
    });
    this.menus.push({
      id: EnumMCGenerales.Copiar,
      descripcion: 'MENUCONTEXTUAL.COPIAR',
      icono: 'content_copy',
      disabled: false,
      divisor: false
    });
    // this.menus.push({ id: EnumMCGenerales.Pegar, descripcion: 'MENUCONTEXTUAL.PEGAR', icono: 'content_paste', disabled: esMaestro, divisor: false  });
    this.menus.push({
      id: EnumMasOpciones.Ajustar,
      descripcion: 'MENUCONTEXTUAL.ALTO_FILA',
      icono: 'wrap_text',
      disabled: false,
      divisor: false
    });
    // this.menus.push({ id: EnumMCGenerales.GuardarLayout, descripcion: 'MENUCONTEXTUAL.GUARDAR_LAYOUT', icono: 'save', disabled: false, divisor: false  });
    // this.menus.push({ id: EnumMCGenerales.ReestablecerLayout, descripcion: 'MENUCONTEXTUAL.RESTABLECER_LAYOUT', icono: 'restore', disabled: false, divisor: false  });
    return this.menus;
  }

  public inicializarInsumoExp(dataExp: ClsCatalogosExpIns, rowId: any): ClsDetalleMatrizInsumos {
    const insumo: ClsDetalleMatrizInsumos = new ClsDetalleMatrizInsumos();
    insumo.Control = rowId;
    insumo.IdCatalogo = dataExp.IdCatalogo;
    insumo.Nivel = dataExp.Nivel;
    insumo.Renglon = 0;
    insumo.Codigo = dataExp.Codigo;
    insumo.Descripcion = dataExp.Descripcion;
    insumo.DescripcionLarga = dataExp.DescripcionLarga;
    insumo.TipoInsumo = this.tipoMatrizDefault;
    insumo.Unidad = dataExp.Unidad;
    insumo.Volumen = 1;
    insumo.Dividir = false;
    insumo.TipoOperacion = '*';
    insumo.EsPorcentaje = dataExp.TipoPorcentaje;
    insumo.EsCostoHorario = dataExp.EsCostoHorario;
    insumo.CostoMoneda1 = dataExp.CostoMoneda1;
    insumo.CostoMoneda2 = dataExp.CostoMoneda2;
    insumo.ImporteMoneda1 = ClsUtil.evaluadorExpresiones(ClsUtil.calcularImporte(insumo.Volumen, dataExp.CostoMoneda1, insumo.Dividir, this.infPpto.decimalredondearimporte), this.infPpto.decimalredondearimporte);
    insumo.ImporteMoneda2 = ClsUtil.evaluadorExpresiones(ClsUtil.calcularImporte(insumo.Volumen, dataExp.CostoMoneda2, insumo.Dividir, this.infPpto.decimalredondearimporte), this.infPpto.decimalredondearimporte);
    insumo.Expresion = '';
    return insumo;
  }

  public inicializarInsumo(data: ClsDetalleMatrizInsumos, dataExp: ClsCatalogosExpIns, cantidad: number, operador: boolean, rowId: any): ClsDetalleMatrizInsumos {
    let insumo: ClsDetalleMatrizInsumos;
    if (ClsUtil.esNulo(data)) {
      insumo = new ClsDetalleMatrizInsumos();
      insumo.Control = rowId;
      insumo.IdCatalogo = BigInt('0');
      insumo.Renglon = 0;
      insumo.Codigo = '';
      insumo.Descripcion = 'Código nuevo';
      insumo.DescripcionLarga = 'Código nuevo';
      insumo.TipoInsumo = this.tipoMatrizDefault;
      insumo.Unidad = 'UNIDAD';
      insumo.Volumen = 1;
      insumo.Dividir = false;
      insumo.TipoOperacion = '*';
      insumo.Nivel = 0;
      insumo.EsPorcentaje = 0;
      insumo.EsCostoHorario = false;
      insumo.CostoMoneda1 = 0;
      insumo.CostoMoneda2 = 0;
      insumo.ImporteMoneda1 = 0;
      insumo.ImporteMoneda2 = 0;
    }
    if (!ClsUtil.esNulo(dataExp)) {
      insumo = new ClsDetalleMatrizInsumos();
      insumo.Control = rowId;
      insumo.IdCatalogoS = dataExp.IdCatalogo.toString();
      // insumo.IdCatalogo = this.infPpto.checkMaestroExpIns ? BigInt('0') : dataExp.IdCatalogo;
      insumo.Nivel = 0;
      insumo.Renglon = 0;
      insumo.Codigo = dataExp.Codigo;
      insumo.Descripcion = dataExp.Descripcion;
      insumo.DescripcionLarga = dataExp.DescripcionLarga;
      insumo.TipoInsumo = dataExp.Tipo;
      insumo.Unidad = dataExp.Unidad;
      insumo.Volumen = cantidad;
      insumo.Dividir = operador;
      insumo.TipoOperacion = operador ? '/' : '*';
      insumo.EsPorcentaje = dataExp.TipoPorcentaje;
      insumo.EsCostoHorario = dataExp.EsCostoHorario;
      dataExp.CostoMoneda1 = ClsUtil.esNulo(dataExp.CostoMoneda1) ? 0 : dataExp.CostoMoneda1;
      dataExp.CostoMoneda2 = ClsUtil.esNulo(dataExp.CostoMoneda2) ? 0 : dataExp.CostoMoneda2;
      insumo.CostoMoneda1 = ClsUtil.evaluadorExpresiones(dataExp.CostoMoneda1, this.infPpto.decimalredondearimporte);
      insumo.CostoMoneda2 = ClsUtil.evaluadorExpresiones(dataExp.CostoMoneda2, this.infPpto.decimalredondearimporte);
      insumo.ImporteMoneda1 = ClsUtil.evaluadorExpresiones(ClsUtil.calcularImporte(cantidad, dataExp.CostoMoneda1, operador, this.infPpto.decimalredondearimporte), this.infPpto.decimalredondearimporte);
      insumo.ImporteMoneda2 = ClsUtil.evaluadorExpresiones(ClsUtil.calcularImporte(cantidad, dataExp.CostoMoneda2, operador, this.infPpto.decimalredondearimporte), this.infPpto.decimalredondearimporte);
    }
    return insumo;
  }

  public inicializarInsumo2(data: ClsDetalleMatrizInsumos): ClsDetalleMatrizInsumos {
    const insumo: ClsDetalleMatrizInsumos = new ClsDetalleMatrizInsumos();
    if (!ClsUtil.esNulo(data)) {
      insumo.Control = data.Control;
      insumo.IdCatalogoS = ClsUtil.esNulo(data.IdCatalogo) ? data.IdCatalogoS : data.IdCatalogo.toString();
      insumo.Renglon = data.Renglon;
      insumo.Codigo = data.Codigo;
      insumo.Descripcion = data.Descripcion;
      insumo.DescripcionLarga = data.DescripcionLarga;
      insumo.TipoInsumo = data.TipoInsumo;
      insumo.Unidad = data.Unidad;
      insumo.Volumen = data.Volumen;
      insumo.Dividir = data.TipoOperacion === '/';
      insumo.TipoOperacion = data.TipoOperacion;
      insumo.Nivel = data.Nivel;
      insumo.EsPorcentaje = data.EsPorcentaje;
      insumo.EsCostoHorario = data.EsCostoHorario;
      insumo.CostoMoneda1 = data.CostoMoneda1;
      insumo.CostoMoneda2 = data.CostoMoneda2;
      insumo.ImporteMoneda1 = ClsUtil.calcularImporte(insumo.Volumen, insumo.CostoMoneda1, insumo.Dividir, this.infPpto.decimalredondearimporte);
      insumo.ImporteMoneda2 = ClsUtil.calcularImporte(insumo.Volumen, insumo.CostoMoneda2, insumo.Dividir, this.infPpto.decimalredondearimporte);
      insumo.Expresion = data.Expresion;
    }
    return insumo;
  }

  public buscarInsumo(codigo: string, insumo: ClsDetalleMatrizInsumos): ClsDetalleMatrizInsumos {
    const busqueda = this.infPpto.pptoActivoCompletoJSON.CatExpIns.find(e => e.Codigo === codigo);
    if (!ClsUtil.esNulo(busqueda)) {
      insumo.IdCatalogo = busqueda.IdCatalogo;
      insumo.Codigo = codigo;
      insumo.Descripcion = busqueda.Descripcion;
      insumo.DescripcionLarga = busqueda.DescripcionLarga;
      insumo.TipoInsumo = busqueda.Tipo;
      insumo.Unidad = busqueda.Unidad;
      insumo.CostoMoneda1 = busqueda.CostoMoneda1;
      insumo.CostoMoneda2 = busqueda.CostoMoneda2;
    }
    return insumo;
  }

  public sustituirIDs(resultado: ClsMatriz): ClsMatriz {
    const matriz: ClsMatriz = new ClsMatriz();
    matriz.IdCodigoMatrizS = ClsUtil.esNulo(resultado.IdCodigoMatriz) ? resultado.IdCodigoMatrizS : resultado.IdCodigoMatriz.toString();
    matriz.CodigoMatriz = resultado.CodigoMatriz;
    matriz.DescripcionMatriz = resultado.DescripcionMatriz;
    matriz.DescripcionLarga = resultado.DescripcionLarga;
    matriz.ObservacionPendiente = resultado.ObservacionPendiente;
    matriz.PendienteAnalizar = resultado.PendienteAnalizar;
    matriz.TipoInsumoMatriz = resultado.TipoInsumoMatriz;
    matriz.UnidadMatriz = resultado.UnidadMatriz;
    matriz.CodigoAuxiliar = resultado.CodigoAuxiliar;
    // matriz.DescripcionAuxiliar = resultado.DescripcionAuxiliar;
    matriz.CostoMoneda1Matriz = resultado.CostoMoneda1Matriz;
    matriz.CostoMoneda2Matriz = resultado.CostoMoneda2Matriz;
    // matriz.JsonMatriz = resultado.JsonMatriz;
    matriz.Insumos = this.sustituirIDsDetalle(resultado.Insumos);
    return matriz;
  }

  public sustituirIDsv2(resultado: ClsMatriz): ClsMatriz {
    const matriz = new ClsMatriz();
    Object.assign(matriz, {
      IdCodigoMatrizS: ClsUtil.esNulo(resultado.IdCodigoMatriz)
        ? resultado.IdCodigoMatrizS
        : resultado.IdCodigoMatriz.toString(),
      CodigoMatriz: resultado.CodigoMatriz,
      DescripcionMatriz: resultado.DescripcionMatriz,
      DescripcionLarga: resultado.DescripcionLarga,
      ObservacionPendiente: resultado.ObservacionPendiente,
      PendienteAnalizar: resultado.PendienteAnalizar,
      TipoInsumoMatriz: resultado.TipoInsumoMatriz,
      UnidadMatriz: resultado.UnidadMatriz,
      CodigoAuxiliar: resultado.CodigoAuxiliar,
      CostoMoneda1Matriz: resultado.CostoMoneda1Matriz,
      CostoMoneda2Matriz: resultado.CostoMoneda2Matriz
    });

    matriz.Insumos = this.sustituirIDsDetallev2(resultado.Insumos);

    return matriz;
  }

  public sustituirIDsDetalle(insumoDet: ClsDetalleMatrizInsumos[]): ClsDetalleMatrizInsumos[] {
    const insumo: ClsDetalleMatrizInsumos[] = [];
    insumoDet.forEach(item => {
      insumo.push(this.inicializarInsumo2(item));
    });
    return insumo;
  }

  public sustituirIDsDetallev2(insumoDet: ClsDetalleMatrizInsumos[]): ClsDetalleMatrizInsumos[] {
    if (!insumoDet?.length) {
      return [];
    }

    // Cache del método (más rápido en loops grandes)
    const initInsumo = this.inicializarInsumo2.bind(this);

    return insumoDet.map(initInsumo);
  }

  public crearObjTransaccionesPeticio(transactionsData: Transaction[], detalleMatriz: ClsDetalleMatrizInsumos[]): ClsDetalleMatrizInsumos[] {
    let catMaestro: Map<string, ClsCatalogosExpIns> = new Map<string, ClsCatalogosExpIns>();
    let existe: ClsCatalogosExpIns;
    const cat: Map<string, ClsCatalogosExpIns> = ClsUtil.crearMapCatalogoCodigo(this.infPpto.pptoActivoCompletoJSON.CatExpIns);
    if (!ClsUtil.esNulo(this.infPpto.pptoMaestroCompletoJSON) && !ClsUtil.esNulo(this.infPpto.pptoMaestroCompletoJSON.CatExpIns)) {
      catMaestro = ClsUtil.crearMapCatalogoCodigo(this.infPpto.pptoMaestroCompletoJSON.CatExpIns);
    }
    transactionsData.forEach(dataMatriz => {
      let index: number;
      switch (dataMatriz.type) {
        case TransactionType.ADD:
          existe = cat.get(dataMatriz.newValue.Codigo);
          // si no existe en cat activo, buscar en maestro
          if (ClsUtil.esNulo(existe)) {
            existe = catMaestro.get(dataMatriz.newValue.Codigo);
            dataMatriz.newValue.IdCatalogo = ClsUtil.esNulo(existe) ? BigInt('0') : existe.IdCatalogo;
          } else {
            dataMatriz.newValue.IdCatalogo = existe.IdCatalogo;
          }
          dataMatriz.newValue.Control = 0;
          dataMatriz.newValue.Dividir = ClsUtil.esNulo(dataMatriz.newValue.TipoOperacion) ? '*' : dataMatriz.newValue.TipoOperacion === '/';
          dataMatriz.newValue.EsPorcentaje = ClsUtil.esNulo(dataMatriz.newValue.EsPorcentaje) ? 0 : dataMatriz.newValue.EsPorcentaje;
          // dataMatriz.newValue.TipoPorcentaje = ClsUtil.esNulo(dataMatriz.newValue.TipoPorcentaje) ? 0 : dataMatriz.newValue.TipoPorcentaje;
          dataMatriz.newValue.EsCostoHorario = ClsUtil.esNulo(dataMatriz.newValue.EsCostoHorario) ? false : dataMatriz.newValue.EsCostoHorario;
          detalleMatriz.push(dataMatriz.newValue);
          break;
        case TransactionType.UPDATE:
          const dataBuscar: ClsDetalleMatrizInsumos = detalleMatriz.find(item => item.Control === dataMatriz.id);
          dataMatriz.newValue.Control = dataBuscar.Control;
          dataMatriz.newValue.IdCatalogo = ClsUtil.bigintX(dataBuscar.IdCatalogoS);
          dataMatriz.newValue.Dividir = ClsUtil.esNulo(dataMatriz.newValue.TipoOperacion) ? dataBuscar.TipoOperacion === '/' : dataMatriz.newValue.TipoOperacion === '/';
          dataMatriz.newValue.EsPorcentaje = ClsUtil.esNulo(dataMatriz.newValue.EsPorcentaje) ? dataBuscar.EsPorcentaje : dataMatriz.newValue.EsPorcentaje;
          // dataMatriz.newValue.TipoPorcentaje = ClsUtil.esNulo(dataMatriz.newValue.TipoPorcentaje) ? 0 : dataMatriz.newValue.TipoPorcentaje;
          dataMatriz.newValue.EsCostoHorario = ClsUtil.esNulo(dataMatriz.newValue.EsCostoHorario) ? dataBuscar.EsCostoHorario : dataMatriz.newValue.EsCostoHorario;
          index = detalleMatriz.indexOf(dataBuscar);
          detalleMatriz[index] = dataMatriz.newValue;
          break;
        case TransactionType.DELETE:
          index = detalleMatriz.findIndex(item => item.Control === dataMatriz.newValue.Control);
          detalleMatriz.splice(index, 1);
          break;
      }
    });

    return detalleMatriz;
  }

  public obtenerIDCatalogo(data: ClsDetalleMatrizInsumos | ClsConceptosPartida): bigint {
    return ClsUtil.esNulo(data.IdCatalogoS) ? data.IdCatalogo : BigInt(data.IdCatalogoS);
  }

  public async verificarSiEsMatriz(data: ClsVectorSearchRow[], catalogos: ClsCatalogosExpIns[]): Promise<ClsVectorSearchRow[]> {
    try {
      if (!catalogos?.length) return data;

      const mapCatalogoCodigo: Map<string, ClsCatalogosExpIns> = ClsUtil.crearMapCatalogoCodigo(catalogos);
      const mapCatalogoId = new Map<string, ClsCatalogosExpIns>(
        catalogos
          .filter(item => item?.IdCatalogo)
          .map(item => [item.IdCatalogo.toString(), item])
      );

      data.forEach(item => {
        const catalogo = (item.idCatalogo && mapCatalogoId.get(item.idCatalogo)) || mapCatalogoCodigo.get(item.codigo);
        item.idCatalogo = catalogo?.IdCatalogo?.toString();
        item.descripcion = catalogo?.DescripcionLarga || catalogo?.Descripcion || item.descripcion;
        item.unidad = catalogo?.Unidad || item.unidad;
        item.tipo = catalogo?.Tipo?.toString() ?? item.tipo;
        item.costo = catalogo?.CostoMoneda1 ?? item.costo;
        item.fecha = catalogo?.FechaMoneda1 ?? item.fecha;
        item.esMatriz = this.esCatalogoMatriz(catalogo);
      });

      return data;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public updateCell(insumo: ClsDetalleMatrizInsumos, rowId: number) {
    // validar moneda
    insumo.CostoMoneda1 = ClsUtil.esNulo(insumo.CostoMoneda1) ? 0 : insumo.CostoMoneda1;
    insumo.CostoMoneda2 = ClsUtil.esNulo(insumo.CostoMoneda2) ? 0 : insumo.CostoMoneda2;
    // Definir los campos a actualizar y sus correspondientes nombres en la cuadrícula
    const campos = [
      {valor: insumo.Control, clave: 'Control'},
      {valor: insumo.IdCatalogo, clave: 'IdCatalogo'},
      {valor: insumo.Renglon, clave: 'Renglon'},
      {valor: insumo.Nivel, clave: 'Nivel'},
      {valor: insumo.Codigo, clave: 'Codigo'},
      {valor: insumo.Descripcion, clave: 'Descripcion'},
      {valor: insumo.DescripcionLarga, clave: 'DescripcionLarga'},
      {valor: insumo.TipoInsumo, clave: 'TipoInsumo'},
      {valor: insumo.Unidad, clave: 'Unidad'},
      {valor: insumo.Volumen, clave: 'Volumen'},
      {valor: insumo.TipoOperacion, clave: 'TipoOperacion'},
      {valor: insumo.Expresion, clave: 'Expresion'},
      {valor: insumo.EsPorcentaje, clave: 'EsPorcentaje'},
      {valor: insumo.EsCostoHorario, clave: 'EsCostoHorario'},
      {valor: insumo.CostoMoneda1, clave: 'CostoMoneda1'},
      {valor: insumo.CostoMoneda2, clave: 'CostoMoneda2'},
      {
        valor: ClsUtil.calcularImporteCadena(insumo.Volumen, insumo.CostoMoneda1, insumo.TipoOperacion, this.infPpto.decimalredondearimporte),
        clave: 'ImporteMoneda1'
      },
      {
        valor: ClsUtil.calcularImporteCadena(insumo.Volumen, insumo.CostoMoneda2, insumo.TipoOperacion, this.infPpto.decimalredondearimporte),
        clave: 'ImporteMoneda2'
      }
    ];

    // Actualizar las celdas en la cuadrícula
    campos.forEach(campo => {
      this.gridMatriz.updateCell(campo.valor, rowId, campo.clave);
    });
  }

  public enterBusInsumo(buscar: string, buscarInicio: boolean) {
    try {
      this.gridMatriz.data.push(...this.gridDataCompleta);
      this.gridDataCompleta = [];
      this.gridDataFiltrada = [];

      buscar = ClsUtil.quitarAcentos(buscar.trim());
      if (buscar === '') {
        this.gridMatriz.data = this.insumos;
        return;
      }

      // Filtrar los datos
      this.gridMatriz.data = this.gridMatriz.data.filter((item: ClsDetalleMatrizInsumos) => {
        if (ClsUtil.filtroGridMatchItem(item, ['Codigo', 'DescripcionLarga', 'Descripcion', 'Unidad'], buscarInicio, buscar)) {
          this.gridDataFiltrada.push(item);
          return true;
        } else {
          this.gridDataCompleta.push(item);
          return false;
        }
      });
    } catch (e) {
      throw new Error(e.message);
    }
    return this.gridDataFiltrada;
  }

  public async obtenerMatriz(idCodigoMatriz: bigint): Promise<ClsMatriz[]> {
    const objPeticion: ClsPeticionMatrices = new ClsPeticionMatrices();
    try {
      objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
      objPeticion.IdPresupuesto = ClsUtil.getPptoSelectedActivoMaestro(this.infPpto).IdPresupuesto;
      objPeticion.IdOrganizacion = ClsUtil.getPptoSelectedActivoMaestro(this.infPpto).IdOrganizacion;
      objPeticion.IdCodigoMatriz = idCodigoMatriz;
      return await this.obtieneMatricesCompleta(objPeticion);
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async obtenerMatrizBusqueda(idCodigoMatriz: bigint, idPresupuesto: bigint, idOrganizacion?: bigint): Promise<ClsMatriz[]> {
    const objPeticion: ClsPeticionMatrices = new ClsPeticionMatrices();
    try {
      objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
      objPeticion.IdPresupuesto = idPresupuesto;
      // objPeticion.IdOrganizacion = idOrganizacion;
      objPeticion.IdCodigoMatriz = idCodigoMatriz;
      return await this.obtieneMatricesCompleta(objPeticion);
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async buscarMatrizIndexedDB(idCatalogo: bigint): Promise<ClsMatriz> {
    const {catalogos, matrices} = await this.indexedDb.obtenerDatosBusquedaAI();

    // en caso de no exitir en local, se inicializa para mostrar la ventana sin detalle
    const resp = this.buscarInicializarMatriz(idCatalogo, catalogos);
    // se busca la matriz en local
    const matriz = matrices.find((m: ClsMatriz) => m.IdCodigoMatriz === idCatalogo);

    if (!matriz) {
      return resp; // ⛔ salida rápida
    }

    const mapCatalogo: Map<bigint, any> = ClsUtil.crearMapIdCatalogo(catalogos);

    return this.construirMatrizListaIndexedDB(resp, matriz, mapCatalogo, 2);
  }

  private async obtieneMatricesCompleta(objPeticion: ClsPeticionMatrices) {
    try {
      const resp = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'ObtieneMatricesCompleta');
      // modo offline
      if (!resp) {
        return [];
      }
      const pptos: ClsRespuestaMatrices = ClsUtil.parseJSONBig(resp);
      if (pptos?.Errores?.ErrorDescripcion !== '') {
        throw new Error(pptos.Errores.ErrorDescripcion);
      }
      return pptos.Matrices ?? [];
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async obtenerTodasLasMatrices(offset: number) {
    this.offset = offset;
    const objPeticion: ClsPeticionConsultarGralsCatalogos = new ClsPeticionConsultarGralsCatalogos();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = this.infPpto.pptoSeleccionadoActivo.IdPresupuesto;
    objPeticion.IdOrganizacion = this.infPpto.organizacion.IdOrganizacion;
    objPeticion.Limit = this.gLimiteRegistro;
    objPeticion.Offset = this.offset * this.gLimiteRegistro; // se incrimenta en base el limite
    try {
      const resp = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'ConsultarMatrices2021');
      // modo offline
      if (!resp) {
        return []; // offline → devolvemos lo que haya cargado
      }
      const matrices: ClsRespuestaTodasLasMatrices = ClsUtil.parseJSONBig(resp);
      if (matrices?.Errores?.ErrorDescripcion !== '') {
        throw new Error(matrices.Errores.ErrorDescripcion);
      }
      this.mLMatrices = this.mLMatrices.concat(matrices.LsCatalogo);
      // si length es igual a limite(30,000) posiblemente hay mas datos para obtener
      // si no es es igual, regresar resultado
      if (matrices.LsCatalogo.length === this.gLimiteRegistro) {
        this.offset++;
        return this.obtenerTodasLasMatrices(this.offset);
      }
      return this.mLMatrices;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async obtenerTodasLasMatricesBasicos(offset: number) {
    this.offset = offset;
    const objPeticion: ClsPeticionConsultarGralsCatalogos = new ClsPeticionConsultarGralsCatalogos();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = this.infPpto.pptoSeleccionadoActivo.IdPresupuesto;
    objPeticion.IdOrganizacion = this.infPpto.organizacion.IdOrganizacion;
    objPeticion.Limit = this.gLimiteRegistro;
    objPeticion.Offset = this.offset * this.gLimiteRegistro; // se incrimenta en base el limite
    try {
      const resp = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'ConsultarMatricesBasicos');
      // modo offline
      if (!resp) {
        return [];
      }
      const matrices: ClsRespuestaTodasLasMatrices = ClsUtil.parseJSONBig(resp);
      if (matrices?.Errores?.ErrorDescripcion !== '') {
        throw new Error(matrices.Errores.ErrorDescripcion);
      }
      this.mLMatrices = this.mLMatrices.concat(matrices.LsCatalogo);
      // si length es igual a limite(30,000) posiblemente hay mas datos para obtener
      // si no es es igual, regresar resultado
      if (matrices.LsCatalogo.length === this.gLimiteRegistro) {
        this.offset++;
        await this.obtenerTodasLasMatricesBasicos(this.offset);
      } else {
        return this.mLMatrices;
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  // public async obtenerValidarConsultasMatrices() {
  //   try {
  //     let actualizado: boolean;
  //     // validar si obj matricesBocket esta vacio ir a obtener la inf del bocket
  //     if (!this.infPpto.objHayMatMaestro) {
  //       this.infPpto.objMatMaestroBocket = await this.obtenerTodasLasMaticesBocket();
  //       return;
  //     }
  //     // si obj matricesBocket tiene inf, validar si la fecha esta actualizada, para no ir a obtener el json de Mat del bocket
  //     actualizado = await this.validaFechaConsultasBocketMat();
  //     if (!actualizado) {
  //       this.infPpto.objMatMaestroBocket = await this.obtenerTodasLasMaticesBocket();
  //     }
  //   } catch (e) {
  //     throw new Error(e.message);
  //   }
  // }

  // public async validaFechaConsultasBocketMat(): Promise<boolean> {
  //   let respuesta: boolean;
  //   const objPeticion: ClsPeticionPresupuestos = new ClsPeticionPresupuestos();
  //   objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
  //   objPeticion.IdPresupuesto = ClsUtil.getPptoSelectedActivoMaestro(this.infPpto).IdPresupuesto;
  //   objPeticion.IdOrganizacion = this.infPpto.organizacion.IdOrganizacion;
  //   respuesta = await this.servicioGen.enviarPeticionCloudRunTextAwait(objPeticion, 'validaFechaConsultasMatrices')
  //     .then(async (resp: any) => {
  //       const valida: ClsValidaFechasConsultas = ClsUtil.parseJSONBig(resp);
  //       try {
  //         if (valida.Errores.ErrorDescripcion !== '') {
  //           throw new Error(valida.Errores.ErrorDescripcion);
  //         } else {
  //           return valida.Estatus;
  //         }
  //       } catch (e) {
  //         throw new Error(e.message);
  //       }
  //     });
  //   return respuesta;
  // }

  // public async obtenerTodasLasMaticesBocket(): Promise<ClsMatriz[]> {
  //   let  respuesta: ClsMatriz[];
  //   const objPeticion: ClsPeticionPresupuestos = new ClsPeticionPresupuestos();
  //   objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
  //   objPeticion.IdPresupuesto = ClsUtil.getPptoSelectedActivoMaestro(this.infPpto).IdPresupuesto;
  //   respuesta = await this.servicioGen.enviarPeticionCloudRunTextAwait(objPeticion, 'ObtieneMatricesStorage')
  //     .then(async (resp: any) => {
  //       const mat: ClsMatriz[] = [];
  //       const result: ClsMatricesStorageZip = ClsUtil.parseJSONBig(resp);
  //       try {
  //         if (result.Errores.ErrorDescripcion !== '') {
  //           throw new Error(result.Errores.ErrorDescripcion);
  //         } else {
  //           const matrices: string = await ClsUtil.descomprimirArchivoBase64(result.Matrices, 'Matrices.txt');
  //           // this.infPpto.objHayMatMaestro = true;
  //           if (ClsUtil.esNulo(matrices)) {
  //             return mat;
  //           }
  //           const objMatS: string[] = ClsUtil.splitEnter(matrices);
  //           const mapMat: Map<bigint, ClsCalculoMatriz[]> = new Map<bigint, ClsCalculoMatriz[]>();
  //           objMatS.forEach(value => {
  //             const filas: string[] = ClsUtil.splitTabs(value);
  //             const llave: bigint = ClsUtil.bigintX(filas[0]);
  //             // existe, obtener los datos y agregar nuevo registro
  //             if (mapMat.has(llave)) {
  //               const valueLlave: ClsCalculoMatriz[] = mapMat.get(llave);
  //               valueLlave.push({IdCodigoInsumo: ClsUtil.bigintX(filas[1]), Dividir: Boolean(ClsUtil.numberX(filas[2])), Renglon: ClsUtil.numberX(filas[3]), Volumen: ClsUtil.numberX(filas[4]), Control: ClsUtil.numberX(filas[5]), Expresion: ClsUtil.cadenaX(filas[6]) });
  //               mapMat.set(llave, valueLlave);
  //             } else {
  //               mapMat.set(llave, [{IdCodigoInsumo: ClsUtil.bigintX(filas[1]), Dividir: Boolean(ClsUtil.numberX(filas[2])), Renglon: ClsUtil.numberX(filas[3]), Volumen: ClsUtil.numberX(filas[4]), Control: ClsUtil.numberX(filas[5]), Expresion: ClsUtil.cadenaX(filas[6]) }]);
  //             }
  //           });
  //           mapMat.forEach((value, key) => {
  //             const objMat: ClsMatriz = new ClsMatriz();
  //             objMat.IdCodigoMatriz = key;
  //             objMat.JsonMatriz = ClsUtil.stringifyJSONBig(value);
  //             objMat.Insumos = value;
  //             mat.push(objMat);
  //           });
  //           return mat;
  //         }
  //       } catch (e) {
  //         throw new Error(e.message);
  //       }
  //     });
  //
  //   return respuesta;
  // }
  /**
   * Este metodo descomprime las matrices: ClsUtil.descomprimirArchivoBase64(matricesZip, 'Matrices.txt');
   * @param matricesZip recibe la data de matrices
   */
  public async crearObjMatrices(matricesZip: string): Promise<ClsMatriz[]> {
    const mat: ClsMatriz[] = [];
    try {
      const matrices: string = await ClsUtil.descomprimirArchivoBase64(matricesZip, 'Matrices.txt');
      if (ClsUtil.esNulo(matrices)) {
        return mat;
      }
      const objMatS: string[] = ClsUtil.splitEnterNeo(matrices);
      const mapMat: Map<bigint, ClsCalculoMatriz[]> = new Map<bigint, ClsCalculoMatriz[]>();
      objMatS.forEach(value => {
        const filas: string[] = ClsUtil.splitTabsNeo(value);
        const llave: bigint = ClsUtil.bigintX(filas[0]);
        // existe, obtener los datos y agregar nuevo registro
        if (mapMat.has(llave)) {
          const valueLlave: ClsCalculoMatriz[] = mapMat.get(llave);
          valueLlave.push({
            IdCodigoInsumo: ClsUtil.bigintX(filas[1]),
            Dividir: Boolean(ClsUtil.numberX(filas[2])),
            Renglon: ClsUtil.numberX(filas[3]),
            Volumen: ClsUtil.numberX(filas[4]),
            Control: ClsUtil.numberX(filas[5]),
            Expresion: ClsUtil.cadenaX(filas[6])
          });
          mapMat.set(llave, valueLlave);
        } else {
          mapMat.set(llave, [{
            IdCodigoInsumo: ClsUtil.bigintX(filas[1]),
            Dividir: Boolean(ClsUtil.numberX(filas[2])),
            Renglon: ClsUtil.numberX(filas[3]),
            Volumen: ClsUtil.numberX(filas[4]),
            Control: ClsUtil.numberX(filas[5]),
            Expresion: ClsUtil.cadenaX(filas[6])
          }]);
        }
      });
      mapMat.forEach((value, key) => {
        const objMat: ClsMatriz = new ClsMatriz();
        objMat.IdCodigoMatriz = key;
        objMat.JsonMatriz = ClsUtil.stringifyJSONBig(value);
        objMat.Insumos = value;
        mat.push(objMat);
      });
      return mat;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  // public async matrizRegistraActualiza(catalogo: ClsMatriz[]) {
  //   const objPeticion: ClsPeticionMatrizRegistraActualiza = new ClsPeticionMatrizRegistraActualiza();
  //   objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
  //   objPeticion.IdPresupuesto = ClsUtil.getPptoSelectedActivoMaestro(this.infPpto).IdPresupuesto;
  //   objPeticion.Catalogo = catalogo;
  //   await this.servicioGen.enviarPeticionCloudRunTextAwait(objPeticion, 'MatrizRegistraActualiza2021')
  //     .then((resp: any) => {
  //       const error: ClsErrores = ClsUtil.parseJSONBig(resp);
  //       try {
  //         if (error.ErrorDescripcion !== '') {
  //           throw new Error(error.ErrorDescripcion);
  //         }
  //       } catch (e) {
  //         throw new Error(e.message);
  //       }
  //     });
  // }

  public async guardarMatrizCRUD(matriz: ClsGuardarMatriz[]): Promise<ClsGuardarConceptosPartidaDetalle[]> {
    let respuesta: ClsGuardarConceptosPartidaDetalle[];
    const objPeticion: ClsPeticionGuardarMatriz = new ClsPeticionGuardarMatriz();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = this.infPpto.pptoSeleccionadoActivo.IdPresupuesto;
    objPeticion.IdOrganizacion = this.infPpto.organizacion.IdOrganizacion;
    objPeticion.IdPresupuestoMaestro = ClsUtil.esNulo(this.infPpto.pptoSeleccionadoMaestro) ? BigInt('0') : this.infPpto.pptoSeleccionadoMaestro.IdPresupuesto;
    objPeticion.Matriz = matriz;
    try {
      respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'RegistraMatricesConceptos');

      // modo offline
      if (!respuesta) {
        return [];
      }
      const addUpdate: ClsRespuestaGuardarConceptos = ClsUtil.parseJSONBig(respuesta);
      if (addUpdate?.Errores?.ErrorDescripcion !== '') {
        throw new Error(addUpdate.Errores.ErrorDescripcion);
      }

      return addUpdate.LsConceptos ?? [];
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async actualizarMatrizReporte(matrices: ClsMatriz[], objViewer: ClsObjViewer): Promise<ClsMatriz[]> {
    let mapTipoIns: Map<number, any> = new Map<number, any>();
    let mapCat: Map<bigint, any> = new Map<bigint, any>();
    try {
      mapTipoIns = await objViewer.obtenerCatalogoTipoInsumos(true);
      mapCat = ClsUtil.crearMapIdCatalogo(this.infPpto.pptoActivoCompletoJSON.CatExpIns);
      matrices.forEach(value => {
        value.Insumos.forEach(value1 => {
          const llave: bigint = ClsUtil.bigintX(value1.IdCodigoInsumo);
          if (mapCat.has(llave)) {
            const cat: ClsCatalogosExpIns = mapCat.get(llave);
            value1.IdCatalogo = cat.IdCatalogo;
            value1.Codigo = cat.Codigo;
            value1.Descripcion = cat.Descripcion;
            value1.DescripcionLarga = cat.DescripcionLarga;
            value1.DescripcionLarga = cat.DescripcionLarga;
            value1.TipoInsumo = cat.Tipo;
            value1.Unidad = cat.Unidad;
            value1.TipoOperacion = value1.Dividir ? '/' : '*';
            value1.Nivel = cat.Nivel;
            value1.EsPorcentaje = cat.TipoPorcentaje;
            value1.EsCostoHorario = cat.EsCostoHorario;
            value1.CostoMoneda1 = cat.CostoMoneda1;
            value1.CostoMoneda2 = cat.CostoMoneda2;
            if (mapTipoIns.has(value1.TipoInsumo)) {
              value1.DescripcionTipoInsumo = mapTipoIns.get(value1.TipoInsumo).DescripcionTipoInsumo;
            }
          }
        });
      });
      matrices.forEach(matriz => (this.calcularCostosPorcentajes(matriz.Insumos)));
    } catch (e) {
      throw new Error(e.message);
    }
    return matrices;
  }

  public calcularCostosPorcentajes(insumos: ClsDetalleMatrizInsumos[]): ClsDetalleMatrizInsumos[] {
    let insumos2: ClsDetalleMatrizInsumos[] = [];
    let mapImpoTipos: Map<number, ClsImportePorTipo> = new Map<number, ClsImportePorTipo>();
    let tipoPorc: ClsDetalleMatrizInsumos[];
    const decimal = this.infPpto.decimalredondearimporte;
    if (insumos.length === 0) {
      return insumos;
    }
    // calculamos volumen, importe M1 y M2
    insumos.forEach(insumo => {
      insumo.Volumen = ClsUtil.redondear(insumo.Volumen, this.infPpto.decimalredondearmatrices);
      insumo.ImporteMoneda1 = ClsUtil.calcularImporteCadena(insumo.Volumen, insumo.CostoMoneda1, insumo.TipoOperacion, decimal);
      insumo.ImporteMoneda2 = ClsUtil.calcularImporteCadena(insumo.Volumen, insumo.CostoMoneda2, insumo.TipoOperacion, decimal);
    });
    insumos2 = insumos;
    // buscar todos los registros que sean porcentajes
    tipoPorc = insumos2.filter(value => value.EsPorcentaje !== 0);
    if (tipoPorc.length > 0) {
      // obtener mapas con saldos finales por tipo %
      mapImpoTipos = ClsUtil.acumularImporteXTipo(tipoPorc, insumos2, decimal);
      // agregar costo moneda 1 y 2 del mapa
      tipoPorc.forEach(value => {
        const importes: ClsImportePorTipo = mapImpoTipos.get(value.EsPorcentaje);
        const insumo: ClsDetalleMatrizInsumos = insumos2.find(value1 => value1.Control === value.Control);
        if (!ClsUtil.esNulo(insumo) && !ClsUtil.esNulo(importes)) {
          insumo.CostoMoneda1 = importes.CostoMoneda1;
          insumo.CostoMoneda2 = importes.CostoMoneda2;
          insumo.ImporteMoneda1 = ClsUtil.calcularImporteCadena(insumo.Volumen, insumo.CostoMoneda1, insumo.TipoOperacion, decimal);
          insumo.ImporteMoneda2 = ClsUtil.calcularImporteCadena(insumo.Volumen, insumo.CostoMoneda2, insumo.TipoOperacion, decimal);
        }
      });
    }
    return insumos;
  }

  public generarObjGuardarMatriz(insumos: ClsDetalleMatrizInsumos[], catExpIns: ClsCatalogosExpIns[]): ClsGuardarMatrizDetalle[] {
    try {
      const respuesta: ClsGuardarMatrizDetalle[] = [];
      const mapCatalogo: Map<bigint, ClsCatalogosExpIns> = ClsUtil.crearMapIdCatalogo(catExpIns);
      insumos.forEach(matriz => {
        let llave: bigint = ClsUtil.bigintX(matriz.IdCatalogo);
        llave = (llave === BigInt('0')) ? ClsUtil.bigintX(matriz.IdCatalogoS) : llave;
        const detalle: ClsGuardarMatrizDetalle = new ClsGuardarMatrizDetalle();
        const detalleCat: ClsCatalogosExpIns2 = new ClsCatalogosExpIns2();
        if (mapCatalogo.has(llave)) {
          const cat: ClsCatalogosExpIns = mapCatalogo.get(llave);
          detalle.Control = matriz.Control;
          detalle.IdCatalogo = cat.DesdeMaestro ? BigInt('0') : ClsUtil.esNulo(matriz.IdCatalogo) ? ClsUtil.bigintX(matriz.IdCatalogoS) : matriz.IdCatalogo;
          detalle.Renglon = matriz.Renglon;
          detalle.Volumen = matriz.Volumen;
          detalle.Dividir = matriz.Dividir;
          detalle.CostoMoneda1 = 0;
          detalle.CostoMoneda2 = 0;
          detalle.Expresion = ClsUtil.esNulo(matriz.Expresion) ? '' : matriz.Expresion;
          detalleCat.IdCatalogo = detalle.IdCatalogo;
          detalleCat.Codigo = matriz.Codigo;
          detalleCat.Descripcion = matriz.Descripcion;
          detalleCat.DescripcionLarga = matriz.DescripcionLarga;
          detalleCat.EsPorcentaje = matriz.EsPorcentaje;
          detalleCat.Familia = ClsUtil.esNulo(cat.Familia) ? '' : cat.Familia;
          detalleCat.Proveedor = ClsUtil.esNulo(cat.Proveedor) ? '' : cat.Proveedor;
          detalleCat.TipoInsumo = matriz.TipoInsumo;
          detalleCat.Unidad = matriz.Unidad;
          detalleCat.Referencia = ClsUtil.esNulo(cat.Referencia) ? '' : cat.Referencia;
          detalleCat.EsCostoHorario = matriz.EsCostoHorario;
          detalleCat.EsConceptosDelPpto = cat.EsConceptosDelPpto;
          detalleCat.Expins = cat.Expins;
          detalleCat.ExpInsl = cat.ExpInsl;
          detalleCat.InsumoIntegrado = cat.InsumoIntegrado;
          detalleCat.Marca = ClsUtil.esNulo(cat.Marca) ? false : cat.Marca;
          detalleCat.Nivel = cat.Nivel;
          detalleCat.Participa = cat.Participa;
          detalleCat.PendienteAnalizar = cat.PendienteAnalizar;
          detalleCat.ObservacionPendiente = ClsUtil.esNulo(cat.ObservacionPendiente) ? '' : cat.ObservacionPendiente;
          detalleCat.CostoMoneda1 = matriz.CostoMoneda1;
          detalleCat.FechaMoneda1 = cat.FechaMoneda1;
          detalleCat.CostoMoneda2 = matriz.CostoMoneda2;
          detalleCat.FechaMoneda2 = cat.FechaMoneda2;
          detalleCat.ArrIdsMatriz = cat.ArrIdsMatriz;
          detalleCat.ArrIdsPartida = cat.ArrIdsPartida;
          detalle.Catalogo = detalleCat;
          respuesta.push(detalle);
        }
      });
      return respuesta;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public generarObjGuardarMatrizv2(insumos: ClsDetalleMatrizInsumos[], catExpIns: ClsCatalogosExpIns[]): ClsGuardarMatrizDetalle[] {
    try {
      const mapCatalogo: Map<bigint, ClsCatalogosExpIns> = ClsUtil.crearMapIdCatalogo(catExpIns);
      const BIGINT_0 = BigInt(0);

      return insumos.reduce<ClsGuardarMatrizDetalle[]>((acc, matriz) => {
        const llave = ClsUtil.bigintX(
          matriz.IdCatalogo && matriz.IdCatalogo !== BIGINT_0
            ? matriz.IdCatalogo
            : matriz.IdCatalogoS
        );

        const cat = mapCatalogo.get(llave);
        if (!cat) {
          return acc; // ⛔ salida rápida
        }

        const idCatalogoFinal = cat.DesdeMaestro
          ? BIGINT_0
          : matriz.IdCatalogo ?? ClsUtil.bigintX(matriz.IdCatalogoS);

        const detalle = new ClsGuardarMatrizDetalle();
        detalle.Control = matriz.Control;
        detalle.IdCatalogo = idCatalogoFinal;
        detalle.Renglon = matriz.Renglon;
        detalle.Volumen = matriz.Volumen;
        detalle.Dividir = matriz.Dividir;
        detalle.CostoMoneda1 = 0;
        detalle.CostoMoneda2 = 0;
        detalle.Expresion = matriz.Expresion ?? '';

        const detalleCat = new ClsCatalogosExpIns2();
        detalleCat.IdCatalogo = idCatalogoFinal;
        detalleCat.Codigo = matriz.Codigo;
        detalleCat.Descripcion = matriz.Descripcion;
        detalleCat.DescripcionLarga = matriz.DescripcionLarga;
        detalleCat.EsPorcentaje = matriz.EsPorcentaje;
        detalleCat.TipoInsumo = matriz.TipoInsumo;
        detalleCat.Unidad = matriz.Unidad;
        detalleCat.EsCostoHorario = matriz.EsCostoHorario;

        // valores desde catálogo
        detalleCat.Familia = cat.Familia ?? '';
        detalleCat.Proveedor = cat.Proveedor ?? '';
        detalleCat.Referencia = cat.Referencia ?? '';
        detalleCat.EsConceptosDelPpto = cat.EsConceptosDelPpto;
        detalleCat.Expins = cat.Expins;
        detalleCat.ExpInsl = cat.ExpInsl;
        detalleCat.InsumoIntegrado = cat.InsumoIntegrado;
        detalleCat.Marca = !!cat.Marca;
        detalleCat.Nivel = cat.Nivel;
        detalleCat.Participa = cat.Participa;
        detalleCat.PendienteAnalizar = cat.PendienteAnalizar;
        detalleCat.ObservacionPendiente = cat.ObservacionPendiente ?? '';
        detalleCat.CostoMoneda1 = matriz.CostoMoneda1;
        detalleCat.FechaMoneda1 = cat.FechaMoneda1;
        detalleCat.CostoMoneda2 = matriz.CostoMoneda2;
        detalleCat.FechaMoneda2 = cat.FechaMoneda2;
        detalleCat.ArrIdsMatriz = cat.ArrIdsMatriz;
        detalleCat.ArrIdsPartida = cat.ArrIdsPartida;

        detalle.Catalogo = detalleCat;
        acc.push(detalle);
        return acc;

      }, []);
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async registraActualizaPendAnalizar(matriz: ClsMatriz) {
    const objPeticion: ClsPeticionRegistraActualizaPendAnalisar = new ClsPeticionRegistraActualizaPendAnalisar();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = this.infPpto.pptoSeleccionadoActivo.IdPresupuesto;
    objPeticion.IdOrganizacion = this.infPpto.organizacion.IdOrganizacion;
    objPeticion.IdCodigoMatriz = ClsUtil.bigintX(matriz.IdCodigoMatrizS);
    objPeticion.PendienteAnalizar = matriz.PendienteAnalizar;
    objPeticion.ObservacionPendiente = matriz.ObservacionPendiente;
    objPeticion.DescripcionLarga = matriz.DescripcionLarga;
    objPeticion.CostoMoneda1 = matriz.Insumos.reduce((acc, cur) => ClsUtil.redondearMoneda(acc + cur.CostoMoneda1), 0);
    objPeticion.CostoMoneda2 = matriz.Insumos.reduce((acc, cur) => ClsUtil.redondearMoneda(acc + cur.CostoMoneda2), 0);
    try {
      const resp = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'RegistraActualizaPendienteAnalizar');
      // modo offline
      if (!resp) {
        return;
      }
      const errores: ClsErrores = ClsUtil.parseJSONBig(resp);
      if (errores?.ErrorDescripcion !== '') {
        throw new Error(errores.ErrorDescripcion);
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public validarCrearObjCatalogos(data: any[], cat: any, allColumnas: string[], objGenerico: ClsObjGenerico, objExpIns: ClsObjExplosionDeInsumos): any {
    const obj: any = {};
    try {
      let insumo: ClsDetalleMatrizInsumos;
      const valCod: string = (cat[allColumnas[1]] as string).toUpperCase();
      const valTipo: any = cat[allColumnas[4]];
      let expIns: ClsCatalogosExpIns = objExpIns.inicializarAsignarRegistro(undefined);
      const expIns2: ClsCatalogosExpIns = objExpIns.buscarCodigoEnExpIns(valCod);
      // // validar longitudes
      // ClsUtil.validarDataMax(valCod, 20, objGenerico, allColumnas[1]);
      // if (!ClsUtil.esNulo(valTipo)) {
      //   const tipo: number = Number(valTipo);
      //   if (tipo <= 0) {
      //     throw new Error('MENSAJES.ALERT.TIPO_INSUMO_NO_VALIDO');
      //   }
      // }
      if (ClsUtil.esNulo(expIns2)) {
        expIns.DesdeMaestro = false;
      } else {
        expIns = expIns2;
      }
      insumo = this.inicializarInsumoExp(expIns, ClsUtil.generarIDNumber());
      insumo.Renglon = ClsUtil.generarRenglon(data);
      // se reemplaza sea nuevo o existente ya que sale la ventana de diferencia y ese es valor a tomar para los campos que si quiere cambiar
      obj.insumos = this.reemplazarInfCatalogo(insumo, cat, allColumnas);
      obj.insumos = this.sustituirIDsDetalle([insumo])[0];
      obj.expIns = expIns;
    } catch (e) {
      throw new Error(e.message);
    }

    return obj;
  }

  public reemplazarInfCatalogo(registro: ClsDetalleMatrizInsumos, cat: any, allColumnas: string[]): ClsDetalleMatrizInsumos {
    const valRenlgon: any = cat[allColumnas[0]];
    const valCod: string = (cat[allColumnas[1]] as string).toUpperCase();
    const valDesCom: string = cat[allColumnas[2]];
    const valDes: string = cat[allColumnas[3]];
    const valTipo: any = cat[allColumnas[4]];
    const valUni: string = cat[allColumnas[5]];
    const valC1: any = cat[allColumnas[6]];
    const valC2: any = cat[allColumnas[7]];
    const valOperador: any = cat[allColumnas[8]];
    const valVol: string = cat[allColumnas[9]];
    const valExpresion: any = cat[allColumnas[10]];
    const valEsPorc: any = cat[allColumnas[11]];
    const valEsCH: any = cat[allColumnas[12]];
    let ch: boolean;
    try {
      if (valCod !== registro.Codigo) {
        registro.Codigo = valCod;
      }
      if (!ClsUtil.esNulo(valDes) && !ClsUtil.esNulo(valDesCom)) {
        if (valDesCom !== registro.DescripcionLarga) {
          registro.DescripcionLarga = valDesCom;
        }
        if (valDes !== registro.Descripcion) {
          registro.Descripcion = valDes.substring(0, 40);
        }
      } else if (!ClsUtil.esNulo(valDes)) {
        if (valDes !== registro.Descripcion) {
          registro.Descripcion = valDes.substring(0, 40);
        }
        if (valDes !== registro.DescripcionLarga) {
          registro.DescripcionLarga = valDes;
        }
      } else if (!ClsUtil.esNulo(valDesCom)) {
        if (valDesCom !== registro.Descripcion) {
          registro.Descripcion = valDesCom.substring(0, 40);
        }
        if (valDesCom !== registro.DescripcionLarga) {
          registro.DescripcionLarga = valDesCom;
        }
      }
      if (!ClsUtil.esNulo(valTipo)) {
        const tipo: number = Number(valTipo);
        if (tipo !== registro.TipoInsumo) {
          registro.TipoInsumo = tipo;
        }
      }
      if (!ClsUtil.esNulo(valUni)) {
        if (valUni !== registro.Unidad) {
          registro.Unidad = valUni.toUpperCase();
        }
      }
      if (!ClsUtil.esNulo(valC1)) {
        const c1: number = ClsUtil.redondearMoneda(ClsUtil.evaluadorExpresiones(ClsUtil.currencyToNumberFormat(valC1), this.infPpto.decimalredondearimporte), this.infPpto.decimalredondearimporte);
        if (c1 !== registro.CostoMoneda1) {
          if (registro.Nivel === 0 && !registro.EsPorcentaje && !registro.EsCostoHorario) {
            registro.CostoMoneda1 = c1;
          }
        }
      }
      if (!ClsUtil.esNulo(valC2)) {
        const c2: number = ClsUtil.redondearMoneda(ClsUtil.evaluadorExpresiones(ClsUtil.currencyToNumberFormat(valC2), this.infPpto.decimalredondearimporte), this.infPpto.decimalredondearimporte);
        if (c2 !== registro.CostoMoneda2) {
          if (registro.Nivel === 0 && !registro.EsPorcentaje && !registro.EsCostoHorario) {
            registro.CostoMoneda2 = c2;
          }
        }
      }
      if (!ClsUtil.esNulo(valOperador)) {
        if (valOperador !== registro.TipoOperacion) {
          registro.TipoOperacion = valOperador;
        }
      }
      if (!ClsUtil.esNulo(valVol)) {
        const vol: number = ClsUtil.evaluadorExpresiones(Number(valVol.replace(',', '.')), this.infPpto.decimalredondearcantidad);
        if (vol !== registro.Volumen) {
          registro.Volumen = vol;
        }
      }
      if (!ClsUtil.esNulo(valExpresion)) {
        if (valExpresion !== registro.Expresion) {
          registro.Expresion = valExpresion.substring(0, 100);
        }
      }
      if (!ClsUtil.esNulo(valEsCH)) {
        ch = valEsCH === '1';
        if (ch !== registro.EsCostoHorario) {
          registro.EsCostoHorario = ch;
        }
      }
      if (!ClsUtil.esNulo(valEsPorc) && !ch) {
        const esPorc: number = Number(valEsPorc);
        if (esPorc !== registro.EsPorcentaje) {
          registro.EsPorcentaje = esPorc;
        }
      }
    } catch (e) {
      throw new Error(e.message);
    }
    return registro;
  }

  /**
   *
   * @param idCatalogo
   * @param catalogos este campo se ocupar por el momento para trabajar con indexedDB
   */
  public buscarInicializarMatriz(idCatalogo: bigint, catalogos?: ClsCatalogosExpIns[]): ClsMatriz {
    const resp: ClsMatriz = new ClsMatriz();
    let pptoJSON: ClsPartidasConceptosExpIns;
    let mapCatalogo: Map<bigint, any>;
    let mapPresupuesto: Map<bigint, any>
    let ppto: ClsConceptosPartida;
    if (ClsUtil.esNulo(catalogos)) {
      pptoJSON = ClsUtil.getPptoCompletoActivoMaestroJSON(this.infPpto);
      mapCatalogo = ClsUtil.crearMapIdCatalogo(pptoJSON.CatExpIns);
      mapPresupuesto = ClsUtil.crearMapIdCatalogo(pptoJSON.Presupuesto);
      ppto = mapPresupuesto.get(idCatalogo);
    } else {
      mapCatalogo = ClsUtil.crearMapIdCatalogo(catalogos);
    }
    const catalogo: ClsCatalogosExpIns = mapCatalogo.get(idCatalogo);

    resp.IdCodigoMatriz = ClsUtil.bigintX(idCatalogo);
    resp.CodigoMatriz = catalogo.Codigo;
    resp.DescripcionMatriz = catalogo.Descripcion;
    resp.DescripcionLarga = catalogo.DescripcionLarga;
    resp.TipoInsumoMatriz = catalogo.Tipo;
    resp.UnidadMatriz = catalogo.Unidad;
    resp.CodigoAuxiliar = ClsUtil.esNulo(ppto) ? '' : ClsUtil.cadenaX(ppto.CodigoAuxiliar);
    resp.CostoMoneda1Matriz = catalogo.CostoMoneda1;
    resp.CostoMoneda2Matriz = catalogo.CostoMoneda2;
    resp.PendienteAnalizar = ClsUtil.esNulo(ppto) ? catalogo.PendienteAnalizar : ppto.PendienteAnalizar;
    resp.ObservacionPendiente = ClsUtil.esNulo(ppto) ? catalogo.ObservacionPendiente : ppto.ObservacionPendiente;
    resp.UrlContenido = ClsUtil.esNulo(ppto) ? catalogo.UrlContenido : ppto.UrlContenido;
    resp.JsonMatriz = '';
    resp.Insumos = [];

    return resp;
  }

  public buscarMatrizLista(idCatalogo: bigint): ClsMatriz {
    let resp: ClsMatriz = new ClsMatriz();
    const allMatrices: ClsMatriz[] = ClsUtil.getPptoCompletoActivoMaestroJSON(this.infPpto).Matrices;
    const mapCatalogo: Map<bigint, any> = ClsUtil.crearMapIdCatalogo(ClsUtil.getPptoCompletoActivoMaestroJSON(this.infPpto).CatExpIns);
    const matriz: ClsMatriz = allMatrices.find(mat => ClsUtil.bigintX(mat.IdCodigoMatriz) === ClsUtil.bigintX(idCatalogo));
    resp = this.buscarInicializarMatriz(idCatalogo);
    if (!ClsUtil.esNulo(matriz)) {
      const insumosFinal: ClsDetalleMatrizInsumos[] = [];
      matriz.Insumos.forEach((insumo: any) => {
        const catInsumo: ClsCatalogosExpIns = mapCatalogo.get(insumo.IdCodigoInsumo);
        insumosFinal.push({
          IdCatalogo: insumo.IdCodigoInsumo,
          Renglon: insumo.Renglon,
          Codigo: catInsumo.Codigo,
          Descripcion: catInsumo.Descripcion,
          DescripcionLarga: catInsumo.DescripcionLarga,
          TipoInsumo: catInsumo.Tipo,
          Unidad: catInsumo.Unidad,
          Volumen: insumo.Volumen,
          Dividir: insumo.Dividir,
          TipoOperacion: insumo.Dividir ? '/' : '*',
          Nivel: catInsumo.Nivel,
          EsPorcentaje: catInsumo.TipoPorcentaje,
          EsCostoHorario: catInsumo.EsCostoHorario,
          CostoMoneda1: catInsumo.CostoMoneda1,
          CostoMoneda2: catInsumo.CostoMoneda2,
          ImporteMoneda1: ClsUtil.calcularImporte(insumo.Volumen, catInsumo.CostoMoneda1, insumo.Dividir, this.infPpto.decimalredondearimporte),
          ImporteMoneda2: ClsUtil.calcularImporte(insumo.Volumen, catInsumo.CostoMoneda2, insumo.Dividir, this.infPpto.decimalredondearimporte),
          Control: insumo.Control,
          Expresion: insumo.Expresion,
        });
      });
      resp.JsonMatriz = matriz.JsonMatriz;
      resp.Insumos = insumosFinal;
    }
    return resp;
  }

  public buscarMatrizListav2(idCatalogo: bigint): ClsMatriz {
    const ppto = ClsUtil.getPptoCompletoActivoMaestroJSON(this.infPpto);
    const idBuscar = ClsUtil.bigintX(idCatalogo);

    const resp = this.buscarInicializarMatriz(idCatalogo);

    const matriz = ppto.Matrices.find(m => ClsUtil.bigintX(m.IdCodigoMatriz) === idBuscar);

    if (!matriz) {
      return resp; // ⛔ salida rápida
    }

    const mapCatalogo: Map<bigint, any> = ClsUtil.crearMapIdCatalogo(ppto.CatExpIns);

    const decimal = this.infPpto.decimalredondearimporte;

    return this.construirMatrizListaIndexedDB(resp, matriz, mapCatalogo, decimal);
  }

  private construirMatrizListaIndexedDB(resp: ClsMatriz, matriz: ClsMatriz, mapCatalogo: Map<bigint, any>, decimal: number): ClsMatriz {
    resp.JsonMatriz = matriz.JsonMatriz;

    resp.Insumos = matriz.Insumos.map(insumo => {
      const cat = mapCatalogo.get(insumo.IdCodigoInsumo)!;
      const dividir = insumo.Dividir;

      return {
        IdCatalogo: insumo.IdCodigoInsumo,
        Renglon: insumo.Renglon,
        Codigo: cat.Codigo,
        Descripcion: cat.Descripcion,
        DescripcionLarga: cat.DescripcionLarga,
        TipoInsumo: cat.Tipo,
        Unidad: cat.Unidad,
        Volumen: insumo.Volumen,
        Dividir: dividir,
        TipoOperacion: dividir ? '/' : '*',
        Nivel: cat.Nivel,
        EsPorcentaje: cat.TipoPorcentaje,
        EsCostoHorario: cat.EsCostoHorario,
        CostoMoneda1: cat.CostoMoneda1,
        CostoMoneda2: cat.CostoMoneda2,
        ImporteMoneda1: ClsUtil.calcularImporte(insumo.Volumen, cat.CostoMoneda1, dividir, decimal),
        ImporteMoneda2: ClsUtil.calcularImporte(insumo.Volumen, cat.CostoMoneda2, dividir, decimal),
        Control: insumo.Control,
        Expresion: insumo.Expresion
      };
    });

    return resp;
  }

  public actualizarListaMatrices(IdCodigoMatriz: bigint, detalleMatriz: ClsGuardarMatrizDetalle[]) {
    const allMatrices: ClsMatriz[] = ClsUtil.getPptoCompletoActivoMaestroJSON(this.infPpto).Matrices;
    const indexMat: number = allMatrices.findIndex(value => value.IdCodigoMatriz === IdCodigoMatriz);
    const insumos = detalleMatriz.map<ClsCalculoMatriz>(d => ({
      IdCodigoInsumo: ClsUtil.bigintX(d.IdCatalogo),
      Dividir: d.Dividir,
      Renglon: d.Renglon,
      Volumen: d.Volumen,
      Control: d.Control,
      Expresion: ClsUtil.cadenaX(d.Expresion)
    }));
    const objMat = new ClsMatriz();
    objMat.IdCodigoMatriz = IdCodigoMatriz;
    objMat.Insumos = insumos;
    objMat.JsonMatriz = ClsUtil.stringifyJSONBig(insumos);
    (indexMat === -1) ? allMatrices.push(objMat) : allMatrices[indexMat] = objMat;
  }

  //#region Traduccion
  public getTranslationsSinMatriz(insumo: string): string {
    return ClsUtil.getTranslations(['MENSAJES.ALERT.SIN_MATRIZ'], this.infApp)['MENSAJES.ALERT.SIN_MATRIZ'].toString().replace('{0}', insumo);
  }

  //#endregion
}
